<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
import { useAppearance } from '@baserow/modules/core/composables/useAppearance'

const { appearance } = useAppearance()

useHead(() => ({
  htmlAttrs: {
    'data-canis-theme': appearance.value,
  },
}))
</script>
